import React from 'react'
import { flipDate } from '../../lib/dates'

export function TablePenalizaciones({ language, penalizaciones }) {
    const handleEstado = (estado, fecha_inicio, fecha_final) => {
        if (!estado) return ''

        const isBetweenDates = new Date() >= new Date(fecha_inicio) && new Date() <= new Date(fecha_final)

        if (estado === 'Penalizado' && isBetweenDates) {
            return language === 'castellano' ? 'Penalización activa' : 'Penalització activa'
        }
        if (estado === 'Penalizado' && !isBetweenDates) {
            return language === 'castellano' ? 'Próxima penalización' : 'Pròxima penalització'
        }

        if (estado === 'Ya penalizado') {
            return language === 'castellano' ? 'Penalización pasada' : 'Penalització passada'
        }
    }
    return (
        <>
            {penalizaciones.length === 0 ? (
                <div className="alert alert-warning" role="alert">
                    {language === 'castellano' ? 'No tienes penalizaciones.' : 'No tens penalitzacions.'}
                </div>
            ) : (
                <div className="overflow-x-auto w-full">
                    <table class="table" className="table">
                        <thead>
                            <tr>
                                {language === 'castellano' ? (
                                    <>
                                        <th scope="col">Descripción</th>
                                        <th scope="col">Fecha inicio</th>
                                        <th scope="col">Fecha final</th>
                                        <th scope="col">Estado</th>
                                    </>
                                ) : (
                                    <>
                                        <th scope="col">Descripció</th>
                                        <th scope="col">Data d'inici</th>
                                        <th scope="col">Data final</th>
                                        <th scope="col">Estat</th>
                                    </>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {penalizaciones?.map(
                                ({ descripcion_cast, descripcion_cat, fecha_inicio, fecha_final, estado }, idx) => (
                                    <tr key={idx}>
                                        <td
                                            className={`text-break text-start align-top ${
                                                new Date() >= new Date(fecha_inicio) &&
                                                new Date() <= new Date(fecha_final)
                                                    ? 'text-danger'
                                                    : ''
                                            }`}
                                            style={{
                                                maxWidth: '300px',
                                                whiteSpace: 'normal',
                                                wordBreak: 'break-word',
                                            }}
                                        >
                                            {language === 'castellano'
                                                ? descripcion_cast.toLowerCase()
                                                : descripcion_cat.toLowerCase()}
                                        </td>
                                        <td>{flipDate(fecha_inicio)}</td>
                                        <td>{flipDate(fecha_final)}</td>
                                        <td>{handleEstado(estado, fecha_inicio, fecha_final)}</td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </>
    )
}
